export type DiscrepancyType = 'overpayment' | 'underpayment';
export type DiscrepancyStatus = 'pending' | 'reviewed' | 'resolved' | 'waived';
export type ResolutionType = 'refund_received' | 'credit_note' | 'additional_payment' | 'waived' | 'other';

export interface ProcurementDiscrepancy {
  id: string;
  procurement_id: string;
  original_paid_amount: number;
  final_calculated_amount: number;
  discrepancy_amount: number;
  discrepancy_type: DiscrepancyType;
  status: DiscrepancyStatus;
  resolution_type?: ResolutionType;
  resolution_notes?: string;
  resolved_by?: string;
  resolved_at?: string;
  created_at: string;
  updated_at: string;
  // Joined data
  procurement?: {
    id: string;
    product_name?: string;
    total_quantity?: number;
    agent?: { name: string } | null;
    supplier?: { name: string } | null;
    created_at: string;
  };
  resolver?: {
    full_name?: string;
    email?: string;
  };
}

export interface CreateDiscrepancyInput {
  procurement_id: string;
  original_paid_amount: number;
  final_calculated_amount: number;
  discrepancy_amount: number;
  discrepancy_type: DiscrepancyType;
}

export interface UpdateDiscrepancyInput {
  status?: DiscrepancyStatus;
  resolution_type?: ResolutionType;
  resolution_notes?: string;
  resolved_by?: string;
  resolved_at?: string;
}

export const RESOLUTION_TYPE_LABELS: Record<ResolutionType, string> = {
  refund_received: 'Refund Received',
  credit_note: 'Credit Note Applied',
  additional_payment: 'Additional Payment Made',
  waived: 'Waived',
  other: 'Other',
};

export const DISCREPANCY_STATUS_LABELS: Record<DiscrepancyStatus, string> = {
  pending: 'Pending Review',
  reviewed: 'Under Review',
  resolved: 'Resolved',
  waived: 'Waived',
};
